import React, { useEffect, useState } from 'react';
import { Button, Space, Table, Tag, Input, Select, DatePicker, Form, message, Modal } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	getUsers,
	getStatistic,
	getStatisticSettle,
	getMeal,
	getUser,
	addOrUpdateDish,
	updateMeals,
	getMealsByID,
	settlementMeal,
	checkmealisdone
} from '../../service/auth/AuthService';
import moment from 'moment';
import { formatMoney } from '../../helper/formatCurrencyHelper';

export default function DetailAssume() {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const idMeal = searchParams.get('idMeal');
	const [userRenderTable, setUserRenderTable] = useState<any>([]);
	const [userRender, setUserRender] = useState<any>([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalOpenSettlement, setisModalOpenSettlement] = useState(false);
	const [inforConfirm, setInforConfirm] = useState<any>({});
	const [meal, setMeal] = useState<any>({});
	const [numberUserId, setNumberUserId] = useState(0);
	

	const onFinish = (values: any) => {
		// console.log(values);
	};

	useEffect(() => {
		getUsers()
			.then(res => {
				setUserRender(res.data.data);
			})
			.catch(err => {
				// console.log(err);
			});
		getMeal()
			.then(res => {
				setUserRenderTable(res.data.result);
			})
			.catch(err => {
				// console.log(err);
			});
		getMealsByID(idMeal)
			.then(res => {
				// console.log(res);
				setMeal(res.data.result);
			})
			.catch(err => {
				// console.log(err);
			});
		getUser()
			.then((res: any) => {
				// console.log(res);
				setNumberUserId(res.data.data.id);
			})
			.catch(err => {
				// console.log(err);
			});
	}, []);

	interface DataType {
		key: string;
		name: string;
		age: number;
		address: string;
		tags: string[];
		status: any;
		price: any;
		need2pay: any;
	}

	const handleConfirm = (record: any) => {
		setIsModalOpen(true);
		setInforConfirm(record);
	};

	const handleOk = async () => {
		const paramsSendDish = [
			{
				name: inforConfirm.name,
				price: parseInt(inforConfirm.price.toString().replaceAll('.', '')),
				need2pay: parseInt(inforConfirm.need2pay.toString().replaceAll('.', '')),
				userid: userRender.find((item: any, index: number) => {
					if (item.fullname === inforConfirm.userid) {
						return item;
					}
				})?.id,
				mealid: inforConfirm.mealid,
				status: 'done',
				created: moment(meal.created).toISOString(),
				modified: moment(meal.modified).toISOString(),
			},
		];

		await addOrUpdateDish(paramsSendDish)
			.then(res => {
				// window.location.replace("/detail-assume?idMeal="+idMeal);
			})
			.catch(err => {
				// console.log(err);
			});
		
		const params = {
			mealid: idMeal
		}
		await checkmealisdone(params)
			.then(res => {
				window.location.replace("/detail-assume?idMeal="+idMeal);
			})
			.catch(err => {
				// console.log(err);
			});
			
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setisModalOpenSettlement(false);
	};

	const columns: ColumnsType<DataType> = [
		{
			title: 'Ngày tạo',
			dataIndex: 'created',
			key: 'created',
		},
		{
			title: 'ID bữa ăn',
			dataIndex: 'mealid',
			key: 'mealid',
		},
		{
			title: 'Món ăn',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Giá',
			dataIndex: 'price',
			key: 'price',
			// render: (_, record) => {
			// 	return (
			// 		<p
			// 			className="mb-0"
			// 			onClick={() => {
			// 				console.log(record);
			// 			}}
			// 		>
			// 			{parseInt(record.price)}
			// 		</p>
			// 	);
			// },
		},
		{
			title: 'Giá thực tế',
			dataIndex: 'need2pay',
			key: 'need2pay',
			// render: (_, record) => {
			// 	return (
			// 		<p
			// 			className="mb-0"
			// 			// className={
			// 			// 	record.status == 'new'
			// 			// 		? 'red-character'
			// 			// 		: record.status == 'paid'
			// 			// 		? 'yellow-character'
			// 			// 		: 'green-character'
			// 			// }
			// 		>
			// 			{formatMoney(record.need2pay)}
			// 		</p>
			// 	);
			// },
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			key: 'status',
			render: (_, record) => {
				return (
					<p
						className={
							record.status == 'new'
								? 'red-character'
								: record.status == 'paid'
								? 'yellow-character'
								: 'green-character'
						}
					>
						{record.status == 'new'
								? 'Chưa trả tiền'
								: record.status == 'paid'
								? 'Đã trả (Hãy xác nhận nếu đã nhận)'
								: 'Đã nhận'}
					</p>
				);
			},
		},
		{
			title: 'Người nợ',
			dataIndex: 'userid',
			key: 'userid',
		},
		{
			title: 'Trả nợ',
			dataIndex: '',
			key: '',
			render: (_, record) => {
				return (
					<Button
						onClick={() => {
							handleConfirm(record);
						}}
						disabled={record.status === 'new' || record.status === 'done' || meal.status === 'done' || meal.status === 'deleted' || meal.status === 'new'}
						type="primary"
					>
						Xác nhận
					</Button>
				);
			},
		},
	];

	const dishes = meal.dishes?.filter((item: any, index: number) => {
		if(item.userid !== numberUserId && item.need2pay != 0) {
			return item;
		}
	});

	const newArrayUserRender = dishes?.map((item: any, index: number) => {
		return {
			created: moment(item.created).format('DD-MM-YYYY'),
			userid: userRender?.find((itemChild: any, index: number) => {
				if (item.userid === itemChild.id ) {
					return item;
				}
			})?.fullname,
			mealid: item.mealid,
			name: item.name,
			price:  formatMoney(item.price) + " VND",
			need2pay: formatMoney(item.need2pay) + " VND",
			status: formatMoney(item.status),
			modified: item.modified
		};
	})

	const totalPriceInitial = 
		newArrayUserRender
		?.filter((item: any, index: number) => {
			if (item.status === 'done') {
				return item;
			}
		})
		.reduce((initial: number, item: any) => {
			return initial + parseInt(item.need2pay.toString().replaceAll('.', ''));
		}, 0);

	const totalMustPriceInitial = newArrayUserRender
		?.filter((item: any, index: number) => {
			if (item.status === 'new' || item.status === 'paid') {
				return item;
			}
		})

		.reduce((initial: number, item: any) => {
			return initial + parseInt(item.need2pay.toString().replaceAll('.', ''));
		}, 0);

	const handleSettlementMeal = () => {
		if(meal.status == "done" ) {
			message.success('Bữa ăn đã đc tất toán rồi!');
			return;
		}
		setisModalOpenSettlement(true);
	};

	const handleSettlement = () => {
		
		const paramsStatistic = {
			mealid: meal.id
		};
		settlementMeal(paramsStatistic)
			.then((res:any) => {
				// console.log(res);
				// setUserRenderTable(res.data.result);
				message.success('Bạn tất toán bữa ăn thành công');
				handleCancel();
				window.location.replace("/detail-assume?idMeal="+idMeal);
			})
			.catch((err : any) => {
				// console.log(err);
				message.error('Bạn tất toán bữa ăn chưa thành công');
			});
	} 

	return (
		<>
			<div className="text-center text-base ">
				<h1 className="my-5 text-lg">Thống kê chi tiết</h1>
				<div className="flex justify-evenly">
					
				</div>
				<div className="flex justify-evenly">
					<p className="text-red-600">Tổng số tiền đã thu : {formatMoney(totalPriceInitial)} VND</p>
					<p className="text-red-600">Tổng số tiền cần thu nợ : {formatMoney(totalMustPriceInitial)} VND</p>
					<Button
						type="primary"
						danger
						onClick={() => {
							handleSettlementMeal();
						}}
					>
						Tất toán bữa ăn
					</Button>
				</div>
				<Form
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 32 }}
					name="dynamic_form_nest_item"
					onFinish={onFinish}
					autoComplete="off"
					// form={formDetailAssume}
				>
					<div className="w-full mx-auto border border-gray-500 p-5 rounded-lg form-order">
						<Table columns={columns} dataSource={newArrayUserRender} pagination={false} />
					</div>
				</Form>
			</div>
			<Modal centered visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
				<p className="text-center">Bạn có đồng ý xác nhận đã thanh toán</p>
			</Modal>

			<Modal centered visible={isModalOpenSettlement} onOk={handleSettlement} onCancel={handleCancel}>
				<p className="text-center">Bạn có đồng ý tất toán bữa ăn này??</p>
			</Modal>
		</>
	)
}
